import { ITest } from "@/modules/assessments/types/test.interface";
import MarkdownPreviewCustom from "@/ui-components/commonComponents/MarkdownPreviewCustom/MarkdownPreviewCustom";
import questionStyle from "@/shared/components/candidate/scenes/TestElement/style.module.css";
import cn from "classnames";
import { StandardizedInstructionsBlock } from "./StandardizedInstructionsBlock/StandardizedInstructionsBlock";
import { getTestSectionsTimeSum } from "./test-instructions.utils";

export interface TestInstructionsProps {
  // Instruction body already resolved to the invite locale by the BE.
  instructions: string;
  test?: ITest;
}

export function TestInstructions({ instructions, test }: TestInstructionsProps) {
  return (
    <>
      {test && (
        <StandardizedInstructionsBlock
          questionCount={test.config.questionCount}
          timeLimitMinutes={getTestSectionsTimeSum(test)}
        />
      )}

      <MarkdownPreviewCustom
        source={instructions}
        className={cn(questionStyle.questionMarkdownWrapper, questionStyle.questionTextWrapper)}
      />
    </>
  );
}
